// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/cbc.scss
// module id = 730
// module chunks = 0